import { Box }                                       from "@mui/material";
import { FlexBox, FooterButton, FullWidth, Section } from "./DualMenu.style";
import { useBreak }                                  from "hooks/useBreak";
import { useLocation, useNavigate }                  from "react-router-dom";
import { getFocus }                                  from "state/jotai";
import { _bootstrap }                                from "state/store.bootstrap";
import { Icon }                                      from "assets/Icons_";
import { SelectFunction }                            from "components/SelectFunction/SelectFunction";
import { ShiftProperty }                             from "components/ShiftProperty/ShiftProperty";
import { Controls }                                  from "components/Isometry/Isometry.Controls";
import { getIsoData, getLowIsoData, setIsoData }     from "state/jotai.isometryDataHooks";
import { ETStyledButton }                            from "components/Button/EusButton";
import { useProjectLabels }                          from "hooks/useProjectLabels";
import { useRotation }                               from "hooks/useRotation";
import { useToggle } from "hooks/useToggle";
import CommoIframenMenus from "components/Iframe/CommonMenus";

export const OverviewDualMenu = (props) => {
const { overlayState, toggleOverlay } = useToggle();
const { getLabel } = useProjectLabels();
const rotation     = useRotation();
const here         = useLocation().pathname;
const isIsometry   = here.includes("isometry");

const config = getIsoData("config");

const frame  = getIsoData("activeframe");
const frames = getLowIsoData("frames");
const index  = getIsoData("snapindex");

const setIndex = setIsoData("snapindex");
const setFrame = setIsoData("activeframe");

const lowQualityPercent = getLowIsoData("percent");
const lowQualityConfig  = getLowIsoData("config");

  const isMobile = useBreak("md_dn");

  const showRotateButton = 
  config?.IMAGE_SNAPFRAMES?.length > 0 &&
  isIsometry &&
  !isMobile &&
  !props.showOldSlider &&
  rotation.turnBuilding;

const showControls = 
  !rotation.rotatemode &&
  lowQualityPercent == 100 &&
  lowQualityConfig?.IMAGE_SNAPFRAMES?.length > 1;
  
  const handleToggleSelect = () => {
    toggleOverlay('selectFunction')
  };

  const handlePropertyToggle = () => {
    toggleOverlay('property')
  };
  
  return (
    <FullWidth clr = {clr}>
      <FlexBox clr = {clr}>
            <CommoIframenMenus />
            <Box sx={{
                        width         : isMobile && !isIsometry ? '100%' : "auto",
                        display       : "flex",
                        justifyContent: isMobile && !isIsometry ? "space-between": "flex-start",
                        gap           : "16px",
                        position      : "relative",
                    }}>
              {!rotation.turnBuilding && (
                <ETStyledButton
                variant = {"secondary-1st-varient"}
                       padding         = {"0px"}
                       width           = {"44px"}
                       onClick         = {handleToggleSelect}>
                 <Icon color           = {'#000'}
                       isFaIcon        = {true}
                       size            = "xl"
                       skipColorChange = {false}
                       wrap            = {{ transform: overlayState.selectFunction ? 'rotate(90deg)' : 'rotate(0deg)'}} icon = "ellipsisvertical" />
                </ETStyledButton>
              )}

                {
                    overlayState.selectFunction && <SelectFunction {...props} rotation={rotation} />
                }
              

              {!rotation.turnBuilding && (
                <ETStyledButton 
                
                      variant = {"secondary-1st-varient"}
                      onClick = {props.clickList}>
                <Icon size    = "xl"
                         
                             isFaIcon  = {true}
                             color     = "#000" icon = "list" />
                        <div className = "eus-button-2 text-content">
                             {getLabel("Boligliste")}
                       </div>
                 
                </ETStyledButton>
              )}

              {!rotation.turnBuilding && (
                <ETStyledButton variant   = {"secondary-1st-varient"} onClick = {handlePropertyToggle}>
                <Icon           icon      = "new_building_icon"
                                size      = "xl"
                                color     = "#000"
                                isFaIcon  = {false} />
                <div className = "eus-button-2 text-content">
                            Skift ejendom
                        </div>
                </ETStyledButton>
              )}
                {
                    overlayState.property && <ShiftProperty />
                }

              {showRotateButton && (
                <ETStyledButton variant = {"secondary-1st-varient"} onClick = {rotation.handleRotate}>
                <Icon color={"#000"}
                      isFaIcon={true}
                       size="lg"
                       icon    = {rotation.isrotate ? "pause" : "play"} />
                       <div className = "eus-button-2 text-content"  >
                            {rotation.isrotate ? "Stop rotation" : "Start rotation"}
                       </div>
                </ETStyledButton>
              )}
            </Box>
            {showControls && (
                <Controls
                    frame    = {frame}
                    setFrame = {setFrame}
                    config   = {lowQualityConfig}
                    frames   = {frames}
                    index    = {index}
                    setIndex = {setIndex}
                />
                )}
      </FlexBox>
    </FullWidth>
  );
};